<template >
  <svg :x="posX" :y="posY">
    <path
      v-for="path in svgPaths"
      :key="path.key"
      :d="path.d"
      stroke="white"
      fill="none"
    />
  </svg>
</template>
<script>
import generateQrCode from '../../util/qr-code.js'
import { store } from '../../store/store'

export default {
  name: 'QrCode',
  props: {
    posterHasFrame: {
      type: Boolean,
      required: true,
    },
  },
  data: function() {
    return {
      svgPaths: [],
    }
  },
  async mounted() {
    // I could not display the svg created from the lib directly, thats why I am doing this xml parsing
    const qrCodeSvgString = await generateQrCode(this.smosterId)
    const parser = new DOMParser()
    const qrCodeXml = parser.parseFromString(qrCodeSvgString, 'application/xml')
    const qrCodeXmlPaths = qrCodeXml.getElementsByTagName('path')
    for (let i = 0; i < qrCodeXmlPaths.length; i++) {
      const path = {
        key: i,
        d: qrCodeXmlPaths[i].getAttribute('d'),
        fill: qrCodeXmlPaths[i].getAttribute('fill'),
        stroke: qrCodeXmlPaths[i].getAttribute('stroke'),
      }
      this.svgPaths.push(path)
    }
  },
  computed: {
    smosterId: function() {
      return store.state.smosterId
    },
    posX: function() {
      return this.posterHasFrame ? 30 : 20
    },
    posY: function() {
      return this.posterHasFrame ? 435 : 450
    },
  },
}
</script>
